module.exports = __webpack_public_path__ + "static/media/banner1v2.94a8b653.png";